<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
            <form class="form" autocomplete="off">
                <div class="">
                    <p>Bước 1: Tải file mẫu excel</p>
                    <el-button @click="exportExcelExample()" type="warning" class="font-weight-bold mr-2 mb-3 text-dark">
                        Xuất file mẫu
                    </el-button>
                </div>
                <div class="">
                    <p>Bước 2: Sau khi cập nhập dữ liệu tại file excel, tiến hành tải file lên hệ thống</p>

                    <label for="upload-input" class="btn btn-primary font-weight-bold mr-2">
                        Upload file
                        <input type="file" id="upload-input" hidden @change="handleFileChange" placeholder="Upload file"
                               ref="myFileInput">
                    </label>
                    <div class="mt-2">
                <span class="bg-da p-2 rounded" v-if="addFile">
                  {{ files_prop?.name }}
                  <svg v-if="files_prop" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-x-circle-fill" viewBox="0 0 16 16" @click="closeFile">
                    <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                  </svg>
                </span>
                    </div>
                    <ValidationProvider vid="0.email_dang_nhap" name="phone" :rules="{}" v-slot="{ errors, classes }">
                        <div class="fv-plugins-message-container">
                            <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                {{
                                    errors[0]
                                }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
            </form>

            <div class="d-flex dialog-footer justify-content-end mt-3">
                <el-button @click="close">Hủy bỏ</el-button>
                <el-button type="submit" @click="importFile">Xác nhận</el-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>

import {IMPORT_SALE_EXCEL} from "@/core/services/store/user/users.module";

export default {
    name: 'DialogImportSales',
    props: {

    },
    data() {
        return {
            files_prop: null,
            addFile: false
        };
    },

    watch: {

    },
    methods: {
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file && file.type.includes('spreadsheet') || file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
                this.files_prop = file;
            } else {
                this.$message.error('Vui lòng chọn đúng định dạng file Excel (.xlsx hoặc .xls)');
                this.files_prop = null;
            }
            this.addFile = true;
        },

        async importFile() {
            if (!this.files_prop) {
                this.$message.error('Vui lòng chọn file để upload');
                return;
            }

            const formData = new FormData();
            formData.append('file', this.files_prop);

            this.loading = true;
            this.loadingConfirm = true;

            try {
                await this.$store.dispatch(IMPORT_SALE_EXCEL, formData);
                this.$message({
                    type: 'success',
                    message: 'Import dữ liệu thành công',
                    showClose: true
                });
                this.close();
            } catch (error) {
                this.$message.error('Upload thất bại');
            } finally {
                this.loading = false;
                this.loadingConfirm = false;
            }
        },

        exportExcelExample() {
            const url = `${process.env.VUE_APP_API_URL}/import-sales/get-import-sale-excel`;
            console.log('url', url)
            const link = document.createElement('a');
            console.log('link',link)
            link.href = url;
            link.setAttribute('download', 'import_sale.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        closeFile() {
            this.files_prop = '',
            this.$refs.myFileInput.value = '';
            this.addFile = false;
        },

        close() {
            this.$emit('close');
            this.closeFile();
        }
    }
};
</script>

<style scoped>
.w-100 {
    width: 100%;
}
</style>
